export default {
  // getterArticleData (state, getters, rootState, rootGetters) {
  //   return state.articleData
  // }
}
